<template>
  <div class="user-guide">
    <!-- 头部 -->
    <header class="header">
      <div class="logo">芝麻开花智能写作平台</div>
      <div class="header-actions">
        <el-button @click="goBack" type="primary" plain>
          <el-icon><ArrowLeft /></el-icon>
          返回首页
        </el-button>
      </div>
    </header>

    <!-- 主要内容 -->
    <main class="main-content">
      <div class="content">
        <!-- 标题部分 -->
        <div class="title-section">
          <h1 class="main-title">用前必看</h1>
        </div>

        <!-- 介绍部分 -->
        <div class="intro-section">
          <p class="intro-text">
            欢迎使用芝麻开花，在这里，您可以根据您的想法、论文题目、参考文献等生成论文范文，帮助您理清写作思路，明确写作逻辑，快速完成毕业论文。
            芝麻开花经过专业的学术训练，具有很大的参考价值，生成的内容原创性很高，满足广大用户查重需求。
            即使是相同题目，每次生成的内容也会不同。
          </p>
        </div>

        <!-- 写作流程部分 -->
        <div class="process-section">
          <h2 class="section-title">写作流程</h2>
          <div class="process-steps">
            <div class="step">
              <div class="step-number">第一步</div>
              <div class="step-content">
                <h3>选择类型</h3>
                <p>在此步骤中，您可以输入您的题目或写作想法，然后选择类型（论文、开题报告、文献综述），帮助芝麻开花更好地理解您的需求。</p>
              </div>
            </div>

            <div class="step">
              <div class="step-number">第二步</div>
              <div class="step-content">
                <h3>确定标题</h3>
                <p>您可以在此处选择合适的题目或输入已经确定的题目。</p>
              </div>
            </div>

            <div class="step">
              <div class="step-number">第三步</div>
              <div class="step-content">
                <h3>确定文献</h3>
                <p>芝麻开花可以分析您的参考文献以供参考。支持多达25篇参考文献。这部分主要使用文章的文献综述/国内外研究现状部分。</p>
              </div>
            </div>

            <div class="step">
              <div class="step-number">第四步</div>
              <div class="step-content">
                <h3>确定摘要</h3>
                <p>在此步骤中，芝麻开花将自动生成论文摘要，您可以参考或直接修改，满意后确认。</p>
              </div>
            </div>

            <div class="step">
              <div class="step-number">第五步</div>
              <div class="step-content">
                <h3>确认大纲</h3>
                <p>在此步骤中，芝麻开花将自动生成论文大纲，您可以参考或直接修改，满意后确认。如果是开题报告，这部分将是开题报告的内容框架，而不是论文大纲。</p>
              </div>
            </div>
          </div>
        </div>

        <!-- 订单查询部分 -->
        <div class="order-section">
          <h2 class="section-title">订单查询</h2>
          <div class="order-content">
            <h3 class="sub-title">文件下载流程</h3>
            <p class="order-text">
              文件下载流程：打开账单，找到对应的支付记录，点开详情页复制商户单号后，查询结果输入编号即可下载对应的文件。
            </p>
            <!-- 账单详情示例 -->
            <div class="bill-example">
              <img src="../assets/dingdan.png" alt="账单详情" class="bill-image" />
            </div>
          </div>
        </div>

        <!-- 常见问题部分 -->
        <div class="faq-section">
          <h2 class="section-title">常见问题</h2>
          <div class="faq-list">
            <div class="faq-item">
              <div class="faq-question">
                <span class="q-label">Q:</span>
                <span class="question-text">生成的毕业论文质量怎么样？</span>
              </div>
              <div class="faq-answer">
                <span class="a-label">A:</span>
                <span class="answer-text">芝麻开花的论文范文是由经过专业训练的大模型生成，围绕标题的内容流畅，逻辑连贯，具有学术风格，能够满足专科、本科、硕士毕业论文的要求。</span>
              </div>
            </div>

            <div class="faq-item">
              <div class="faq-question">
                <span class="q-label">Q:</span>
                <span class="question-text">查重率大概是多少？</span>
              </div>
              <div class="faq-answer">
                <span class="a-label">A:</span>
                <span class="answer-text">论文是由模型根据输入信息和上下文创造性构建的，确保原创性。一般稿件的重复率在5%-20%。芝麻开花保证官方系统查重在25%以内，如果超过25%，可以联系客服免费重新生成或退款。</span>
              </div>
            </div>

            <div class="faq-item">
              <div class="faq-question">
                <span class="q-label">Q:</span>
                <span class="question-text">文章会在系统内保存多久？</span>
              </div>
              <div class="faq-answer">
                <span class="a-label">A:</span>
                <span class="answer-text">芝麻开花不保留论文范文，下单后请及时下载保存，一周后系统会完全清除，无法恢复。</span>
              </div>
            </div>

            <div class="faq-item">
              <div class="faq-question">
                <span class="q-label">Q:</span>
                <span class="question-text">毕业论文要加载多久可以出来？</span>
              </div>
              <div class="faq-answer">
                <span class="a-label">A:</span>
                <span class="answer-text">付款后预计10-30分钟出结果，如果长时间文件未出现，请联系客服。</span>
              </div>
            </div>

            <div class="faq-item">
              <div class="faq-question">
                <span class="q-label">Q:</span>
                <span class="question-text">可以按照我的目录生成吗？</span>
              </div>
              <div class="faq-answer">
                <span class="a-label">A:</span>
                <span class="answer-text">可以，最后的大纲步骤可以根据您的需求进行修改。</span>
              </div>
            </div>

            <div class="faq-item">
              <div class="faq-question">
                <span class="q-label">Q:</span>
                <span class="question-text">参考文献去哪里找，没有的话可以乱填么？</span>
              </div>
              <div class="faq-answer">
                <span class="a-label">A:</span>
                <span class="answer-text">您可以从知网导出新的参考文献，然后输入到芝麻开花系统中，效果会更好。您也可以不输入参考文献生成文章，但参考文献部分可能不符合您的想法和需求。</span>
              </div>
            </div>

            <div class="faq-item">
              <div class="faq-question">
                <span class="q-label">Q:</span>
                <span class="question-text">我的隐私会被泄露吗？</span>
              </div>
              <div class="faq-answer">
                <span class="a-label">A:</span>
                <span class="answer-text">芝麻开花采用游客模式，我们不会获取用户的任何个人信息。另外，芝麻开花不保留论文范文，一周后系统会完全清除。</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 联系客服部分 -->
        <div class="contact-section">
          <h2 class="section-title">联系客服</h2>
          <div class="contact-content">
            <img src="../assets/kefu.png" alt="联系客服" class="kefu-image" />
          </div>
        </div>

        <!-- 声明部分 -->
        <div class="disclaimer-section">
          <h2 class="section-title">声明</h2>
          <div class="disclaimer-content">
            <p class="disclaimer-text">
              芝麻开花创建的示例内容仅供参考，用户应根据自己的需求创作自己的作品，不得用于代写等不诚信行为。
            </p>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { ArrowLeft } from '@element-plus/icons-vue'

const router = useRouter()

const goBack = () => {
  router.push('/')
}
</script>

<style scoped>
.user-guide {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* 头部样式 */
.header {
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
}

.logo {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}

.header-actions {
  display: flex;
  gap: 15px;
}

/* 主要内容 */
.main-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
}

.content {
  background: white;
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.title-section {
  text-align: center;
  margin-bottom: 40px;
}

.main-title {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin: 0;
}

.intro-section {
  margin-bottom: 50px;
}

.intro-text {
  font-size: 16px;
  line-height: 1.8;
  color: #555;
  text-align: justify;
  margin: 0;
}

.process-section {
  margin-bottom: 50px;
}

.section-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 30px;
  border-bottom: 2px solid #e9ecef;
  padding-bottom: 10px;
}

.process-steps {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.step {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.step-number {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  font-weight: bold;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  min-width: 80px;
  text-align: center;
  flex-shrink: 0;
}

.step-content h3 {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin: 0 0 10px 0;
}

.step-content p {
  font-size: 15px;
  line-height: 1.6;
  color: #666;
  margin: 0;
}

.order-section {
  margin-bottom: 50px;
}

.order-content {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 8px;
  border-left: 4px solid #667eea;
}

.sub-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin: 0 0 15px 0;
}

.order-text {
  font-size: 15px;
  line-height: 1.6;
  color: #666;
  margin: 0 0 20px 0;
}

/* 账单示例样式 */
.bill-example {
  margin-top: 20px;
  text-align: center;
}

.bill-image {
  max-width: 300px;
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 常见问题样式 */
.faq-section {
  margin-bottom: 50px;
}

.faq-list {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.faq-item {
  border: 1px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
}

.faq-question {
  background: #f8f9fa;
  padding: 16px 20px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.q-label {
  background: #667eea;
  color: white;
  font-weight: bold;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  flex-shrink: 0;
  margin-top: 2px;
}

.question-text {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  line-height: 1.5;
}

.faq-answer {
  padding: 16px 20px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: white;
}

.a-label {
  background: #28a745;
  color: white;
  font-weight: bold;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  flex-shrink: 0;
  margin-top: 2px;
}

.answer-text {
  font-size: 15px;
  line-height: 1.6;
  color: #666;
}

/* 联系客服样式 */
.contact-section {
  margin-bottom: 50px;
}

.contact-content {
  text-align: center;
  padding: 30px;
  background: #f8f9fa;
  border-radius: 8px;
}

.kefu-image {
  max-width: 300px;
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 声明样式 */
.disclaimer-section {
  margin-bottom: 30px;
}

.disclaimer-content {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 8px;
  padding: 20px;
}

.disclaimer-text {
  font-size: 12px;
  line-height: 1.4;
  color: #856404;
  margin: 0;
  text-align: center;
  word-wrap: break-word;
  word-break: break-word;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header {
    padding: 15px 20px;
    flex-direction: column;
    gap: 15px;
  }
  
  .main-content {
    padding: 20px 15px;
  }
  
  .content {
    padding: 20px;
  }
  
  .main-title {
    font-size: 24px;
  }
  
  .step {
    flex-direction: column;
    gap: 15px;
  }
  
  .step-number {
    align-self: flex-start;
  }
  
  .faq-question,
  .faq-answer {
    padding: 12px 16px;
  }
  
  .question-text,
  .answer-text {
    font-size: 14px;
  }
  
  .bill-image,
  .kefu-image {
    max-width: 100%;
  }
}
</style>
